// extracted by mini-css-extract-plugin
export default {"intellect-card-inspiration":"index_intellect-card-inspiration__aovy8"};